
class Sliders {
    
    constructor() {

        this.init();
    }

    init() {

    	let $this = this;

        const opts = {
           perView: 6,
           type: 'carousel',
           focusAt: 'center',
           gap: 10,
           breakpoints: {
               1024: { perView: 3 },
               767 : { perView: 2 },
               480 : { perView: 1 }
            }

        };

        document.querySelectorAll(".glide").forEach(function(item){
          var slider = new Glide( item, opts).mount()
        });

    }

}

export default Sliders;



// WEBPACK FOOTER //
// ./scripts/components/sliders.js